// extracted by mini-css-extract-plugin
export var amount = "giftConfirmation_amount__Ehn-M";
export var code = "giftConfirmation_code__xYFVO";
export var container = "giftConfirmation_container__OkkRY";
export var details = "giftConfirmation_details__YX87Z";
export var email = "giftConfirmation_email__fZAuM";
export var giftCard = "giftConfirmation_giftCard__FHu3j";
export var header = "giftConfirmation_header__ZCwt1";
export var message = "giftConfirmation_message__V4SQj";
export var sendAnother = "giftConfirmation_sendAnother__ZAmkU";
export var text = "giftConfirmation_text__quufo";
export var wave = "giftConfirmation_wave__kpX6w";